var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComparisonTypeFacilityPlatforms(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 6H20C18.3431 6 17 7.34315 17 9V17C17 18.6569 18.3431 20 20 20H32C33.6569 20 35 18.6569 35 17V9C35 7.34315 33.6569 6 32 6Z",
    fill: "#8080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H4C2.89543 26 2 26.8954 2 28V32C2 33.1046 2.89543 34 4 34H14C15.1046 34 16 33.1046 16 32V28C16 26.8954 15.1046 26 14 26Z",
    fill: "#FF6833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26H22C20.8954 26 20 26.8954 20 28V32C20 33.1046 20.8954 34 22 34H32C33.1046 34 34 33.1046 34 32V28C34 26.8954 33.1046 26 32 26Z",
    fill: "#FF6833"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26H39C37.8954 26 37 26.8954 37 28V32C37 33.1046 37.8954 34 39 34H49C50.1046 34 51 33.1046 51 32V28C51 26.8954 50.1046 26 49 26Z",
    fill: "#FF6833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonTypeFacilityPlatforms);
export default __webpack_public_path__ + "static/media/comparison-type-facility-platforms.cb438aff9e853e71c07951e04b524617.svg";
export { ForwardRef as ReactComponent };